export const fantomZaps = [
  {
    // SpookySwap
    zapAddress: '0x8afc0f9BdC5DcA9f0408Df03A03520bFa98A15aF',
    ammRouter: '0xF491e7B69E4244ad4002BC14e878a34207E38c29',
    ammFactory: '0x152eE697f2E276fA89E96742e9bB9aB1F2E61bE3',
    ammPairInitHash: '0xcdf2deca40a0bd56de8e3ce5c7df6727e5b1bf2ac96f283fa9c4b3e6b42ea9d2',
  },
  {
    // JetSwap
    zapAddress: '0x63934e5aba120f2bae2418711ef0f20f7db26cd2',
    ammRouter: '0x845E76A8691423fbc4ECb8Dd77556Cb61c09eE25',
    ammFactory: '0xf6488205957f0b4497053d6422F49e27944eE3Dd',
    ammPairInitHash: '0xa5e6089ea250dac750e4867fc4ce7f2a864bd94446564351fe9329f378963974',
  },
  {
    // SpiritSwap
    zapAddress: '0x5618c4C0A9c024e77eb9A5b4424f492f94C86F14',
    ammRouter: '0x16327E3FbDaCA3bcF7E38F5Af2599D2DDc33aE52',
    ammFactory: '0xEF45d134b73241eDa7703fa787148D9C9F4950b0',
    ammPairInitHash: '0xe242e798f6cee26a9cb0bbf24653bf066e5356ffeac160907fe2cc108e238617',
  },
  {
    // Sushi
    zapAddress: '0xFA884e17f04341542790453b1B9A0e6F587768ce',
    ammRouter: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    ammFactory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    ammPairInitHash: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  },
  {
    // WigoSwap
    zapAddress: '0x21371d119bD22917eE2bd05497aE24d0CA3eE8F6',
    ammRouter: '0x5023882f4D1EC10544FCB2066abE9C1645E95AA0',
    ammFactory: '0xC831A5cBfb4aC2Da5ed5B194385DFD9bF5bFcBa7',
    ammPairInitHash: '0x55c39e9406ff3c89a193882b4752879e73c8a0ce1222fe1de34c5e8f6482d9b6',
  },
  {
    // TombSwap
    zapAddress: '0xf12FEe3837492D8fc09D4D0dbbA72919Ea76d19B',
    ammRouter: '0x6D0176C5ea1e44b08D3dd001b0784cE42F47a3A7',
    ammFactory: '0xE236f6890F1824fa0a7ffc39b1597A5A6077Cfe9',
    ammPairInitHash: '0x2dfbcf1b907f911bc66d083d103a1d7de0b8b21a6cb2a66a78d1f1559018fba4',
  },
];
